var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { updateValueByIdentifier } from '../tags/values/update-by-identifier';
import { getValueByIdentifier } from '../tags/values/get-by-identifier';
import { IDENTIFIERS } from '../types/Identifiers';
import { siteIDs } from '../adapters/utils';
import { WIX_DATA_PAGE_URL, STATIC_PAGE_URL } from '../item-types/consts';
import { buildLink } from '../types/builders';
var PREV_REL = 'prev';
var NEXT_REL = 'next';
var CANONICAL_REL = 'canonical';
export var resolvePagination = function (tags, context) {
    var _a;
    if (tags === void 0) { tags = []; }
    if (context === void 0) { context = {}; }
    var _b = context, _c = siteIDs.CURRENT_PAGE_NUMBER, currentPageNumber = _b[_c], _d = siteIDs.TOTAL_PAGE_COUNT, totalPageCount = _b[_d], _e = siteIDs.QUERY_PARAMS_CURRENT, currentQueryParams = _b[_e], _f = siteIDs.QUERY_PARAMS_TOTAL, totalQueryParams = _b[_f];
    var isFirstPage = Number(currentPageNumber) === 1;
    var paginationComponentsTags = [
        !isFirstPage
            ? buildPaginationLink(context, currentQueryParams, currentPageNumber, PREV_REL)
            : undefined,
        currentPageNumber < totalPageCount
            ? buildPaginationLink(context, currentQueryParams, currentPageNumber, NEXT_REL, totalQueryParams)
            : undefined,
    ].filter(function (tag) { return !!tag; });
    if (!currentPageNumber || !totalPageCount || isFirstPage) {
        return {
            resolvedTags: __spreadArray(__spreadArray([], paginationComponentsTags, true), tags, true),
            resolvedContext: context,
        };
    }
    var title = getValueByIdentifier(tags, IDENTIFIERS.TITLE);
    var paginationSuffix = "".concat(currentPageNumber, "/").concat(totalPageCount);
    var legacyBlogPagination = "Page ".concat(currentPageNumber, " of ").concat(totalPageCount);
    if ((title === null || title === void 0 ? void 0 : title.endsWith(paginationSuffix)) ||
        (title === null || title === void 0 ? void 0 : title.endsWith(legacyBlogPagination))) {
        return {
            resolvedTags: tags,
            resolvedContext: context,
        };
    }
    var updatedTitleTag = updateValueByIdentifier(tags, IDENTIFIERS.TITLE, "".concat(title, " ").concat(paginationSuffix));
    if (currentQueryParams) {
        var updatedDescriptionTag = updateValueByIdentifier(__spreadArray(__spreadArray([], paginationComponentsTags, true), updatedTitleTag, true), IDENTIFIERS.DESCRIPTION, '');
        var canonical = buildPaginationUrl(context, currentQueryParams, currentPageNumber, CANONICAL_REL);
        return {
            resolvedTags: updatedDescriptionTag,
            resolvedContext: __assign(__assign({}, context), (_a = {}, _a[WIX_DATA_PAGE_URL] = canonical, _a[STATIC_PAGE_URL] = canonical, _a)),
        };
    }
    return {
        resolvedTags: updatedTitleTag,
        resolvedContext: context,
    };
};
var buildPaginationLink = function (context, currentQueryParams, currentPageNumber, rel, totalQueryParams) {
    var url = buildPaginationUrl(context, currentQueryParams, currentPageNumber, rel, totalQueryParams);
    if (url) {
        return buildLink({ rel: rel, href: url });
    }
};
var buildPaginationUrl = function (context, queryParams, currentPageNumber, rel, totalQueryParams) {
    if (queryParams) {
        var pageURL = context[WIX_DATA_PAGE_URL] || context[STATIC_PAGE_URL];
        if (pageURL) {
            try {
                var urlObject_1 = new URL(pageURL);
                Object.keys(queryParams)
                    .sort()
                    .forEach(function (queryParam) {
                    var value = queryParams[queryParam];
                    if (!(rel === CANONICAL_REL && value === 1)) {
                        if (rel === PREV_REL && value === currentPageNumber) {
                            value = value - 1;
                        }
                        if (rel === NEXT_REL && value < totalQueryParams[queryParam]) {
                            value = value + 1;
                        }
                        urlObject_1.searchParams.set(queryParam, value);
                    }
                });
                return decodeURI(urlObject_1.toString());
            }
            catch (_a) {
                return pageURL;
            }
        }
    }
};
